import BaseResource from './index'
import RoleResource from './role'

export default class SkillResource extends BaseResource {
    static endpoint = '/skills'
    static cacheMaxAge = 3600
    static related() {
        return {
            roles: RoleResource,
        }
    }
}
